const TELEGRAM_LINK_PREFIXES = ['https://t.me/', 'https://telegram.me/'];

/**
 * Check whether a link points to Telegram (t.me or telegram.me) and should be
 * opened natively via openTelegramLink instead of an external browser.
 */
export function isTelegramLink(link: string): boolean {
  return TELEGRAM_LINK_PREFIXES.some((prefix) => link.startsWith(prefix));
}

/**
 * openTelegramLink from @telegram-apps/sdk only accepts https://t.me/... URLs,
 * so telegram.me links must be rewritten before the call. The client resolves
 * the path natively (web_app_open_tg_link) without ever requesting the domain.
 */
export function toOpenableTelegramLink(link: string): string {
  return link.replace(/^https:\/\/telegram\.me\//, 'https://t.me/');
}
